module.exports = __webpack_public_path__ + "img/rku10-6.8b0f5268.png";